module.exports = __webpack_public_path__ + "static/media/lifeline_step_5_neg.d715920c.png";